import { ResponseBase } from '../response-base.model';
import { Preguntas } from './preguntas.model';
export class ListadoPreguntas extends ResponseBase {
    idEncuesta: number;
    idSeccion: number;
    preguntas: Preguntas [] = [];
}
